import { render } from "./FormBuilder.vue?vue&type=template&id=faa9f0cc&scoped=true"
import script from "./FormBuilder.vue?vue&type=script&lang=ts"
export * from "./FormBuilder.vue?vue&type=script&lang=ts"

import "./FormBuilder.vue?vue&type=style&index=0&id=faa9f0cc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-faa9f0cc"

export default script